import {
  DELETE_EMBRYOLOGY_BIOPSY_FILES,
  DELETE_EMBRYOLOGY_DAY_FILE,
  RESET_EMBRYOLOGY_DATA,
  SET_EMBRYOLOGY_BIOPSY_FILES,
  SET_EMBRYOLOGY_DATA,
  SET_EMBRYOLOGY_DAY_FILE,
  SET_EMBRYOLOGY_FROZEN_FILES,
} from '../actions/embryologyActions';
import { patientInitialState } from './initialState';

export const emptyBiopsyRow = {
  embryoNumber: '',
  day: '',
  embryoCode: '',
  grade: '',
  embryoStatus: '',
  dnaDetected: '',
  resultOfGeneticAnalysis: '',
  interpretation: '',
  embryoTransfer: '',
};

export const embryoTransferredDataRow = {
  embryoNumber: '',
  code: '',
  culture: '',
  grade: '',
};

export const emptyFreezingInventoryRow = {
  dateOfOpu: '',
  dayOfCryopreservation: '',
  numberOfCryoDevice: '',
  numberOfEmbryos: '',
  dateOfThawing: '',
  numberOfCryoDeviceThawed: '',
  numberOfEmbryosThawed: '',
};
export const thawingDetailsRow = {
  cryoDeviceNo: '',
  dateOfOpu: '',
  dayOfEmbryoCulture: '',
  grade: '',
  dateOfThawing: '',
  postThawSurvival: '',
  postThaWGrade: '',
  extendedEmbryoCulture: '',
  embryoDate: '',
  embryoDay: '',
  gradeAtFET: '',
  images: [],
  fate: '',
};

export const cryopreservationInitialDataRow = {
  strawNumber: '',
  oocyteEmbryoNo: '',
  oocyteEmbryoCode: '',
  day: '',
  numberOfOocytesOrEmbryos: '',
  cellNoOrGrade: '',
};

export const freezingInfoRow = {
  embryoStatus: '',
  strawColor: '',
};

export const freezingLocationRow = {
  tank: '',
  canister: '',
  visoColorOrCaneNumber: '',
  gobletColor: '',
};

export const cryopreservationDurationRow = {
  durationOfCryopreservationMonths: '',
  durationOfCryopreservationYears: '',
  expiryDate: '',
};

export const cryopreservationThawingDetailsRow = {
  thawingDate: '',
  embryoTransferred: '',
  numberOfEmbryoTransferred: '',
  noOfEmbryoRefrozen: '',
  noOfEmbryoDiscarded: '',
};

export const day0Row = {
  type: '',
  maturity: '',
  maturityOther: '',
  comm: '',
  image: [],
};

export const day1Row = {
  pn: '',
  pb: '',
  comm: '',
  image: [],
};

export const day2Row = {
  cell: '',
  grade: '',
  frag: '',
  comm: '',
  image: [],
};

export const day3Row = {
  cell: '',
  grade: '',
  comm: '',
  image: [],
};

export const day4Row = {
  blastocystCulture: '',
  stage: '',
  grade: '',
  comm: '',
  image: [],
};

export const day5Row = {
  stage: '',
  expansion: '',
  innerCellMassGrade: '',
  trophectodermGrade: '',
  overallGrade: '',
  comm: '',
  image: [],
};

export const day6Row = {
  stage: '',
  expansion: '',
  innerCellMassGrade: '',
  trophectodermGrade: '',
  overallGrade: '',
  comm: '',
  image: [],
  fate: '',
  strawNumber: '',
  oocyteEmbryoCode: '',
  day: '',
  cellNoOrGrade: '',
};

export const initialFrozenTransferState = {
  caseTypeOoctye: '',
  caseTypeSperm: '',
  thawingDetails: [{ ...thawingDetailsRow }],
  noOfStrawThawed: '',
  embryoTransferredData: [{ ...embryoTransferredDataRow }],
  noOfEmbThawed: '',
  noOfEmbSurvived: '',
  idAndStrawWitness: '',
  idAndStrawWitness2: '',
  thawingDoneBy: '',
  witness: '',
  date: '',
  time: '',
  media: '',
  transfer: '',
  surrogateName: '',
  surrogateAge: '',
  surrogateAadharNumber: '',
  surrogateMPI: '',
  additionalRequirement: [
    {
      name: 'LAH',
      label: 'LAH',
      checked: false,
    },
    {
      name: 'Embryo Glue',
      label: 'Embryo Glue',
      checked: false,
    },
    {
      name: 'Extended Culture',
      label: 'Extended Culture',
      checked: false,
    },
    {
      name: 'Others',
      label: 'Others',
      checked: false,
    },
  ],
  additionalRequirementOther: '',
  noOfEmbryoTransfered: '',
  gradeOfEmbryo: '',
  noOfEmbryoRefrozen: '',
  noOfEmbryoDiscarded: '',
  embryoRetentionAfterET: '',
  transferDetails: '',
  BloodOfTheCatheter: '',
  BloodOfTheCatheterReason: 'Inner',
  BloodOfTheCatherCheckbox: [
    {
      name: 'Inner',
      label: 'Inner',
      checked: false,
    },
    {
      name: 'Outer',
      label: 'Outer',
      checked: false,
    },
  ],
  EndometrialThickness: '',
  mucusOnTheCatheter: '',
  mucusOnTheCatheterReason: 'Inner',
  mucusOnTheCatherCheckbox: [
    {
      name: 'Inner',
      label: 'Inner',
      checked: false,
    },
    {
      name: 'Outer',
      label: 'Outer',
      checked: false,
    },
  ],
  embryologist: '',
  clinician: '',
  dishWitness: '',
  patientIdWitness: '',
  remarks: '',
  ETCathetar1: '',
  ETCathetar2: '',
  obturator: '',
  bhcgPositive: '',
  bhcgValue1: '',
  bhcgValue2: '',
  biochemicalPregnany: '',
  noOfSAC: '',
  clinicalPregnancyDetailsClinical: '',
  FHR: '',
  ectopic: '',
  ongoingPregnancy: '',
  clinicalPregnancyDetailsComments: '',
  noOfChildren: '',
  gender: [''],

  liveBirthDetailsComments: '',
};

export const initialState = {
  selectedPatientData: {
    isFetched: false,
    patient: patientInitialState,
    patientFiles: [],
  },
  summary: {
    treatingDoctor: '',
    date: '',
    triggerTime: '',
    timeOfOPU: '',
    finishingTime: '',
    clinician: '',
    embryologist: '',
    nurse: '',
    anaesthetist: '',
    sourceOfOocyte: 'Self',
    oocyteType: 'Fresh',
    donorName: '',
    donorAge: '',
    donorAadharNumber: '',
    donorMPI: '',
    procedure: 'IVF',
    expectedFollicles: '',
    retrievedOCC: '',
    embSign: '',
    witnessSign: '',
    comment: '',
    sperm: '',
    spermType: '',
    abstinance: '',
    donorCode: '',
    donorBank: '',
    retrieval: [
      {
        name: 'Ejaculate',
        label: 'Ejaculate',
        checked: false,
      },
      {
        name: 'PESA',
        label: 'PESA',
        checked: false,
      },
      {
        name: 'TESA',
        label: 'TESA',
        checked: false,
      },
      {
        name: 'TESE',
        label: 'TESE',
        checked: false,
      },
      {
        name: 'm-TESE',
        label: 'm-TESE',
        checked: false,
      },
    ],
    timeOfSampleCollection: '',
    processingTime: '',
    methodOfPreparation: [
      {
        name: 'Swim Up',
        label: 'Swim Up',
        checked: false,
      },
      {
        name: 'DG',
        label: 'DG',
        checked: false,
      },
      {
        name: 'Other',
        label: 'Other',
        checked: false,
      },
    ],
    methodOfPreparationOther: '',
    denudationCoc: '',
    denudationMii: '',
    denudationMi: '',
    denudationGv: '',
    denudationOther: '',
    denudationTime: '',
    oocyteQuality: '',
    denudedBy: '',
    occDenudationComment: '',
    occDenudationWitness: '',
    preWash: {
      volume: '',
      concentration: '',
      totalMotility: '',
      progressiveMotility: '',
      morphology: '',
    },
    postWash: {
      volume: '',
      concentration: '',
      totalMotility: '',
      progressiveMotility: '',
      morphology: '',
    },
    preparedBy: '',
    witnessedBy: '',
    spermQuality: '',
    spermPreparationComment: '',
    methodOfFertilization: [
      {
        name: 'IVF',
        label: 'IVF',
        checked: false,
      },
      {
        name: 'ICSI',
        label: 'ICSI',
        checked: false,
      },
      {
        name: 'Other',
        label: 'Other',
        checked: false,
      },
    ],
    methodOfFertilizationOther: '',
    icsiCoc: '',
    icsiMii: '',
    icsiMi: '',
    icsiGv: '',
    icsiOther: '',
    isciNumberOfMiiInjected: '',
    isciEmbSign: '',
    isciWitnessSign: '',
    isciComment: '',
    typeofICSI: [
      {
        name: 'ICSI',
        label: 'ICSI',
        checked: false,
      },
      {
        name: 'PICSI',
        label: 'PICSI',
        checked: false,
      },
      {
        name: 'IMSI',
        label: 'IMSI',
        checked: false,
      },
      {
        name: 'HA-ICSI',
        label: 'HA-ICSI',
        checked: false,
      },
      {
        name: 'Other',
        label: 'Other',
        checked: false,
      },
    ],
    typeOfICSIOther: '',
    ivfCoc: '',
    inseminationConc: '',
    inseminationTime: '',
    inseminationEmbSign: '',
    inseminationWitnessSign: '',
    inseminationComment: '',
  },
  biopsy: {
    lab: '',
    date: '',
    time: '',
    biopsySci: '',
    biopsyWitness: '',
    tubingSci: '',
    tubingWitness: '',
    biopsyFiles: [],
    rows: [{ ...emptyBiopsyRow }],
  },
  embryoTransferDetails: {
    embryoTransfer: '',
    date: '',
    time: '',
    media: '',
    transfer: '',
    surrogateName: '',
    surrogateAge: '',
    surrogateAadharNumber: '',
    surrogateMPI: '',
    additionalRequirement: [
      {
        name: 'LAH',
        label: 'LAH',
        checked: false,
      },
      {
        name: 'Embryo Glue',
        label: 'Embryo Glue',
        checked: false,
      },
      {
        name: 'Extended Culture',
        label: 'Extended Culture',
        checked: false,
      },
      {
        name: 'Others',
        label: 'Others',
        checked: false,
      },
    ],
    additionalRequirementOther: '',
    embryoTransferredData: [{ ...embryoTransferredDataRow }],
    transferDetails: '',
    BloodOfTheCatheter: '',
    BloodOfTheCatheterReason: 'Inner',
    BloodOfTheCatherCheckbox: [
      {
        name: 'Inner',
        label: 'Inner',
        checked: false,
      },
      {
        name: 'Outer',
        label: 'Outer',
        checked: false,
      },
    ],
    EndometrialThickness: '',
    mucusOnTheCatheter: '',
    mucusOnTheCatheterReason: 'Inner',
    mucusOnTheCatherCheckbox: [
      {
        name: 'Inner',
        label: 'Inner',
        checked: false,
      },
      {
        name: 'Outer',
        label: 'Outer',
        checked: false,
      },
    ],
    embryologist: '',
    clinician: '',
    dishWitness: '',
    patientIdWitness: '',
    remarks: '',
    ETCathetar1: '',
    ETCathetar2: '',
    obturator: '',
    bhcgPositive: '',
    bhcgValue1: '',
    bhcgValue2: '',
    biochemicalPregnany: '',
    noOfSAC: '',
    clinicalPregnancyDetailsClinical: '',
    FHR: '',
    ectopic: '',
    ongoingPregnancy: '',
    clinicalPregnancyDetailsComments: '',
    noOfChildren: '',
    gender: [''],
    liveBirthDetailsComments: '',
  },
  embryoFrozenTransferDetails: {
    caseTypeOoctye: '',
    caseTypeSperm: '',
    thawingDetails: [{ ...thawingDetailsRow }],
    noOfStrawThawed: '',
    embryoTransferredData: [{ ...embryoTransferredDataRow }],
    noOfEmbThawed: '',
    noOfEmbSurvived: '',
    idAndStrawWitness: '',
    idAndStrawWitness2: '',
    thawingDoneBy: '',
    witness: '',
    date: '',
    time: '',
    media: '',
    transfer: '',
    surrogateName: '',
    surrogateAge: '',
    surrogateAadharNumber: '',
    surrogateMPI: '',
    additionalRequirement: [
      {
        name: 'LAH',
        label: 'LAH',
        checked: false,
      },
      {
        name: 'Embryo Glue',
        label: 'Embryo Glue',
        checked: false,
      },
      {
        name: 'Extended Culture',
        label: 'Extended Culture',
        checked: false,
      },
      {
        name: 'Others',
        label: 'Others',
        checked: false,
      },
    ],
    additionalRequirementOther: '',
    noOfEmbryoTransfered: '',
    gradeOfEmbryo: '',
    noOfEmbryoRefrozen: '',
    noOfEmbryoDiscarded: '',
    embryoRetentionAfterET: '',
    transferDetails: '',
    BloodOfTheCatheter: '',
    BloodOfTheCatheterReason: 'Inner',
    BloodOfTheCatherCheckbox: [
      {
        name: 'Inner',
        label: 'Inner',
        checked: false,
      },
      {
        name: 'Outer',
        label: 'Outer',
        checked: false,
      },
    ],
    EndometrialThickness: '',
    mucusOnTheCatheter: '',
    mucusOnTheCatheterReason: 'Inner',
    mucusOnTheCatherCheckbox: [
      {
        name: 'Inner',
        label: 'Inner',
        checked: false,
      },
      {
        name: 'Outer',
        label: 'Outer',
        checked: false,
      },
    ],
    embryologist: '',
    clinician: '',
    dishWitness: '',
    patientIdWitness: '',
    remarks: '',
    ETCathetar1: '',
    ETCathetar2: '',
    obturator: '',
    bhcgPositive: '',
    bhcgValue1: '',
    bhcgValue2: '',
    biochemicalPregnany: '',
    noOfSAC: '',
    clinicalPregnancyDetailsClinical: '',
    FHR: '',
    ectopic: '',
    ongoingPregnancy: '',
    clinicalPregnancyDetailsComments: '',
    noOfChildren: '',
    gender: [''],

    liveBirthDetailsComments: '',
  },
  oocyteEmbryo: {
    day0: {
      date: '',
      incubator: '',
      sci: '',
      witness: '',
      time: '',
      data: [{ ...day0Row }],
    },
    day1: {
      date: '',
      sci: '',
      witness: '',
      time: '',
      data: [{ ...day1Row }],
    },
    day2: {
      date: '',
      sci: '',
      witness: '',
      time: '',
      data: [{ ...day2Row }],
    },
    day3: {
      date: '',
      sci: '',
      witness: '',
      time: '',
      data: [{ ...day3Row }],
    },
    day4: {
      date: '',
      sci: '',
      witness: '',
      time: '',
      data: [{ ...day4Row }],
    },
    day5: {
      date: '',
      sci: '',
      witness: '',
      time: '',
      data: [{ ...day5Row }],
    },
    day6: {
      date: '',
      sci: '',
      witness: '',
      time: '',
      data: [{ ...day6Row }],
    },
  },
  cryopreservation: {
    initialData: {
      data: [{ ...cryopreservationInitialDataRow }],
    },
    freezingInfo: {
      date: '',
      time: '',
      method: '',
      vitrificationMedia: '',
      sci: '',
      witness: '',
      data: [{ ...freezingInfoRow }],
    },
    freezingLocation: {
      durationOfCryopreservationMonths: '',
      durationOfCryopreservationYears: '',
      expiryDate: '',

      sci: '',
      witness: '',
      data: [{ ...freezingLocationRow }],
    },
    thawingDetails: {
      time: '',
      sci: '',
      witness: '',
      data: [{ ...cryopreservationThawingDetailsRow }],
    },
  },

  summaryReport: {
    name: '',
    partnerName: '',
    mpiNo: '',
    date: '',
    treatingDoctor: '',
    oocyteOrigin: '',
    semenOrigin: '',
    oocyteStatus: '',
    ovumPickupDate: '',
    retrievedOcc: '',
    noOfMatureOcytes: '',
    noOfImmatureOocytes: {
      mi: '',
      gv: '',
      others: '',
    },
    totalOocytesForICSI: '',
    totalOocytesForIVF: '',
    oocytesComments: '',
    preWash: {
      volume: '',
      concentration: '',
      totalMotility: '',
    },
    postWash: {
      volume: '',
      concentration: '',
      totalMotility: '',
    },
    spermComments: '',
    normalFertilization: '',
    gradeABCCount: '',
    embryoDevelopment: [
      {
        day: '',
        cellNoOrStage: '',
        grade: '',
        state: '',
      },
    ],
    totalUsableEmbryos: {
      day3: '',
      day5: '',
      day6: '',
    },
    numberOfEmbryosTransferred: {
      day3: '',
      day5: '',
      day6: '',
    },
    numberOfEmbryosBiopsy: {
      day3: '',
      day5: '',
      day6: '',
    },
    numberOfEmbryoCryopreserved: {
      day3: '',
      day5: '',
      day6: '',
    },
    numberOfEmbryoObservation: '',
    numberOfEmbryosDiscarded: {
      day3: '',
      day5: '',
      day6: '',
    },

    reportComments: '',
    embryologist: '',
  },
  freezingInventory: {
    data: [{ ...emptyFreezingInventoryRow }],
    remainingCryoDevice: '',
    remainingEmbryos: '',
    freezingDurationYears: '',
    freezingDurationMonths: '',
    dateOfExpiry: '',
  },

  opuCycles: [],
  fetCycles: [],
  refresh: false,
  selectedProcess: '',
  isNewReport: false,
};

const updateNestedState = (state, keyPath, value) => {
  if (!keyPath) {
    console.error('Invalid keyPath:', keyPath);
    return state; // Return original state if keyPath is invalid
  }

  const keys = keyPath.split('.');
  const newState = { ...state };

  let current = newState;

  for (let i = 0; i < keys.length - 1; i++) {
    const key = keys[i];

    if (!key || !(key in current)) {
      console.error('Invalid key in path:', key);
      return state; // If any key is invalid, return the original state
    }

    // Ensure immutability for arrays and objects
    if (Array.isArray(current[key])) {
      current[key] = [...current[key]];
    } else {
      current[key] = { ...current[key] };
    }

    current = current[key];
  }

  const finalKey = keys[keys.length - 1];

  if (finalKey) {
    if (value !== null && value !== undefined) {
      current[finalKey] = value; // Only update if the final key is valid
    }
  } else {
    console.error('Empty key at the end of the keyPath');
  }

  return newState;
};

const embryologyReducer = (state = initialState, action) => {
  switch (action.type) {
    case SET_EMBRYOLOGY_DATA:
      return updateNestedState(
        state,
        action.payload.keyPath,
        action.payload.value,
      );
    case RESET_EMBRYOLOGY_DATA:
      return initialState;

    case SET_EMBRYOLOGY_BIOPSY_FILES:
      return {
        ...state,
        biopsy: {
          ...state.biopsy,
          biopsyFiles: action.payload,
        },
      };
    case SET_EMBRYOLOGY_FROZEN_FILES:
      return {
        ...state,
        embryoFrozenTransferDetails: {
          ...state.embryoFrozenTransferDetails,
          thawingDetails: {
            ...state.embryoFrozenTransferDetails.thawingDetails,
            data: action.payload,
          },
        },
      };
    case DELETE_EMBRYOLOGY_BIOPSY_FILES:
      const newFiles = state.biopsy.biopsyFiles.filter(
        (file) => file?.fileId !== action.payload.fileId,
      );
      return {
        ...state,
        biopsy: {
          ...state.biopsy,
          biopsyFiles: newFiles,
        },
      };
    case SET_EMBRYOLOGY_DAY_FILE:
      return {
        ...state,
        oocyteEmbryo: {
          ...state.oocyteEmbryo,
          [`day${action.payload.day}`]: {
            ...state.oocyteEmbryo[`day${action.payload.day}`],
            data: [
              ...state.oocyteEmbryo[`day${action.payload.day}`].data.slice(
                0,
                action.payload.index,
              ),
              {
                ...state.oocyteEmbryo[`day${action.payload.day}`].data[
                  action.payload.index
                ],
                image: action.payload.file,
              },
              ...state.oocyteEmbryo[`day${action.payload.day}`].data.slice(
                action.payload.index + 1,
              ),
            ],
          },
        },
      };
    case DELETE_EMBRYOLOGY_DAY_FILE:
      return {
        ...state,
        oocyteEmbryo: {
          ...state.oocyteEmbryo,
          [`day${action.payload.day}`]: {
            ...state.oocyteEmbryo[`day${action.payload.day}`],
            data: [
              ...state.oocyteEmbryo[`day${action.payload.day}`].data.slice(
                0,
                action.payload.index,
              ),
              {
                ...state.oocyteEmbryo[`day${action.payload.day}`].data[
                  action.payload.index
                ],
                image: [],
              },
              ...state.oocyteEmbryo[`day${action.payload.day}`].data.slice(
                action.payload.index + 1,
              ),
            ],
          },
        },
      };
    default:
      return state;
  }
};

export default embryologyReducer;
